import React from "react";
import { Container, Divider, Grid, Typography, Paper, TextField, Button, IconButton, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, CircularProgress, Avatar, Alert } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import globals from "../globals";
import { display, styled, width } from "@mui/system";
import TitleTypography from "../components/course_edit/typogrpahy_title";
import EditCourseTF from "../components/course_edit/tf";
import { Theme, useTheme } from '@mui/material/styles';
import RTE from "../components/course_edit/rich_text_editor";
import FileUpload from "../components/course_edit/button_upload_file";
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import Input from "@mui/material/Input";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { useAuth } from "../context/AuthContext";
import { useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete"
import VisibilityIcon from "@mui/icons-material/Visibility"
import CloseIcon from "@mui/icons-material/Close"
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Slide from "@mui/material/Slide";
import CoursePage from "../course_page/coursePage";
import { DEFAULT_COURSE_PRICE_EUR, formatLevaTooltip } from "../utils";

const PreviewTransition = React.forwardRef(function PreviewTransition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const levels = [
    'Всички',
    'Начинаещи',
    'Напреднали',
    'Професионалисти',
];

const categories = [
    'Английски език',
    'Български език',
    'Бизнес и Маркетинг',
    'Биология',
    'География',
    'Дизайн',
    'Електротехника',
    'Информационни технологии',
    'Испански език',
    'История',
    'Италиански език',
    'Математика',
    'Немски език',
    'Общообразователни предмети (до 4ти клас)',
    'Популярни курсове',
    'Програмиране',
    'Статистика',
    'Счетоводство',
    // 'Турски език',
    'Финанси',
    'Френски език',
    'Химия',
    'Хоби'
];

const timeStamps = [
    '45',
    '60',
    '90',
    '120'
]

function getStyles(level, levelType, theme) {
    return {
        fontWeight: levelType.includes(level)
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular,
    };
}


const OKButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.lightRed,
    '&:hover': {
        backgroundColor: globals.colors.darkRed,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))

const CancelButton = styled(Button)(() => ({
    color: globals.colors.textColor,
    backgroundColor: globals.colors.backgroundColor,
    '&:hover': {
        backgroundColor: globals.colors.gray,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))


const AddTopicButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.darkBlue,
    '&:hover': {
        backgroundColor: globals.colors.lightBlue,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))

const EditCourseAdmin = () => {
    const { courseId } = useParams();
    const isEditMode = Boolean(courseId);
    const { user, token } = useAuth();

    const theme = useTheme();
    const [isCourseLoading, setIsCourseLoading] = React.useState(isEditMode);
    const [courseLoadError, setCourseLoadError] = React.useState('');
    const [levelType, setLevelType] = React.useState([]);
    const [categoryType, setCategoryType] = React.useState([]);
    const [timeStamp, setTimeStamp] = React.useState(60);
    const [numStudents, setNumStudents] = React.useState(1);
    const [publishButtonActive, setPublishButtonActive] = React.useState(false);
    const [draftPublishButtonActive, setDraftPublishButtonActive] = React.useState(false);
    const [loadingAction, setLoadingAction] = React.useState(null);
    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [files, setFiles] = React.useState([]);
    const requestUrl = isEditMode ? `${globals.apiUrl}/courses/${courseId}` : `${globals.apiUrl}/courses/`;
    const requestType = isEditMode ? 'PUT' : 'POST';

    const [students, setStudents] = React.useState([]);
    const [isStudentsLoading, setIsStudentsLoading] = React.useState(false);
    const [studentsLoadError, setStudentsLoadError] = React.useState('');
    const [openDialog, setOpenDialog] = React.useState(false);

    const [studentToAdd, setStudentToAdd] = React.useState('');
    const [adminUsersForEnroll, setAdminUsersForEnroll] = React.useState([]);
    const [enrollSubmitting, setEnrollSubmitting] = React.useState(false);
    const [enrollDialogError, setEnrollDialogError] = React.useState('');
    const [removingStudentId, setRemovingStudentId] = React.useState(null);
    const [studentsActionError, setStudentsActionError] = React.useState('');

    const [courseUrlSlug, setCourseUrlSlug] = React.useState('');
    const [courseSlugFeedback, setCourseSlugFeedback] = React.useState({ severity: 'info', text: '' });
    const [courseSlugCheckLoading, setCourseSlugCheckLoading] = React.useState(false);
    const [courseSlugSaveLoading, setCourseSlugSaveLoading] = React.useState(false);

    const parseApiError = async (response) => {
        const data = await response.json().catch(() => ({}));
        const d = data.detail;
        if (typeof d === 'string')
            return d;
        if (Array.isArray(d))
            return d.map((x) => x.msg || JSON.stringify(x)).join('; ');
        return response.statusText || 'Възникна грешка';
    };

    const refreshEnrolledStudents = React.useCallback(async () => {
        if (!courseId)
            return;
        setIsStudentsLoading(true);
        setStudentsLoadError('');
        try {
            const response = await fetch(`${globals.apiUrl}/courses/enrollments/${courseId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = await response.json();
            if (!response.ok || data.detail)
                throw new Error(typeof data.detail === 'string' ? data.detail : 'Неуспешно зареждане на учениците');
            setStudents(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error fetching enrolled students:', error);
            setStudents([]);
            setStudentsLoadError('Учениците не можаха да бъдат заредени.');
        } finally {
            setIsStudentsLoading(false);
        }
    }, [courseId, token]);

    const handleRemoveUser = async (studentId) => {
        if (!isEditMode || removingStudentId != null)
            return;
        setRemovingStudentId(studentId);
        setStudentsActionError('');
        try {
            const response = await fetch(
                `${globals.apiUrl}/admin/courses/${courseId}/students/${studentId}/enroll`,
                {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                },
            );
            if (!response.ok) {
                const msg = await parseApiError(response);
                throw new Error(msg);
            }
            setStudentsActionError('');
            await refreshEnrolledStudents();
        } catch (error) {
            console.error('Remove student:', error);
            setStudentsActionError(error?.message || String(error) || 'Неуспешно премахване на ученика.');
        } finally {
            setRemovingStudentId(null);
        }
    };

    const handleClickOpen = () => {
        setEnrollDialogError('');
        setStudentsActionError('');
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        setEnrollDialogError('');
        setStudentToAdd('');
    };

    const resolveStudentIdToEnroll = () => {
        const raw = studentToAdd.trim();
        if (!raw)
            return { error: 'Въведете имейл или ID на ученик.' };

        if (/^\d+$/.test(raw)) {
            const id = parseInt(raw, 10);
            if (id <= 0)
                return { error: 'Невалиден ID.' };
            return { studentId: id };
        }

        const emailLower = raw.toLowerCase();
        const match = adminUsersForEnroll.find(
            (u) =>
                String(u.email || '').toLowerCase() === emailLower
                && String(u.role || '').toLowerCase() === 'student',
        );
        if (!match)
            return { error: 'Не е намерен ученик с този имейл. Можете да въведете числовия ID на профила.' };
        return { studentId: match.id };
    };

    const handleAddStudent = async (event) => {
        event.preventDefault();
        if (!isEditMode || enrollSubmitting)
            return;

        const resolved = resolveStudentIdToEnroll();
        if (resolved.error) {
            setEnrollDialogError(resolved.error);
            return;
        }

        setEnrollSubmitting(true);
        setEnrollDialogError('');
        try {
            const response = await fetch(
                `${globals.apiUrl}/admin/courses/${courseId}/students/${resolved.studentId}/enroll`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                },
            );
            if (!response.ok) {
                const msg = await parseApiError(response);
                throw new Error(msg);
            }
            setStudentToAdd('');
            handleClose();
            await refreshEnrolledStudents();
        } catch (error) {
            console.error('Enroll student:', error);
            setEnrollDialogError(error?.message || String(error) || 'Неуспешно записване на ученика.');
        } finally {
            setEnrollSubmitting(false);
        }
    };
    //console.log("timeStamp", timeStamp);

    const [courseData, setCourseData] = React.useState({
        title: '',
        description: '',
        price: DEFAULT_COURSE_PRICE_EUR,
        student_requirements: "",
        example_topics: "",
        included_materials: "",
        good_for: "",
        duration: 45,
        is_published: false,
        is_approved: false,
        image_url: '',
    });

    React.useEffect(() => {
        if (!isEditMode)
            return;

        setIsCourseLoading(true);
        setCourseLoadError('');

        fetch(`${globals.apiUrl}/courses/${courseId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(async (response) => {
                const data = await response.json();
                if (!response.ok || data.detail)
                    throw new Error(data.detail || 'Неуспешно зареждане на курса');

                setCourseData({
                    title: data.title || '',
                    description: data.description || '',
                    price: data.price || DEFAULT_COURSE_PRICE_EUR,
                    student_requirements: Array.isArray(data.student_requirements) ? data.student_requirements.join('\n') : '',
                    example_topics: Array.isArray(data.example_topics) ? data.example_topics.join('\n') : '',
                    included_materials: Array.isArray(data.included_materials) ? data.included_materials.join('\n') : '',
                    good_for: Array.isArray(data.good_for) ? data.good_for : [],
                    duration: data.duration ?? 45,
                    is_published: Boolean(data.is_published),
                    is_approved: Boolean(data.is_approved),
                    image_url: data.image_url || '',
                });
                setLevelType(Array.isArray(data.good_for) ? data.good_for : []);
                setCategoryType(Array.isArray(data.category) ? data.category : []);
                setNumStudents(data.capacity ?? 1);
                setTimeStamp(data.duration ?? 60);
                setCourseInstructorId(data.instructor_id ?? null);
            })
            .catch((error) => {
                console.error('Error:', error);
                setCourseLoadError('Курсът не можа да бъде зареден.');
            })
            .finally(() => {
                setIsCourseLoading(false);
            });
    }, [courseId, isEditMode, token]);

    React.useEffect(() => {
        if (!isEditMode || !courseId || !token)
            return;
        let cancelled = false;
        fetch(
            `${globals.apiUrl}/admin/url-slugs?target_type=course&target_id=${encodeURIComponent(courseId)}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            },
        )
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
                if (!cancelled && data && data.slug)
                    setCourseUrlSlug(data.slug);
            })
            .catch(() => { });
        return () => {
            cancelled = true;
        };
    }, [isEditMode, courseId, token]);

    React.useEffect(() => {
        if (!isEditMode)
            return;
        refreshEnrolledStudents();
    }, [isEditMode, refreshEnrolledStudents]);

    React.useEffect(() => {
        if (!openDialog || !token)
            return;
        let cancelled = false;
        fetch(`${globals.apiUrl}/admin/users/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        })
            .then((r) => r.json())
            .then((data) => {
                if (!cancelled)
                    setAdminUsersForEnroll(Array.isArray(data) ? data : []);
            })
            .catch(() => {
                if (!cancelled)
                    setAdminUsersForEnroll([]);
            });
        return () => {
            cancelled = true;
        };
    }, [openDialog, token]);

    const handleChangeLevel = (event) => {
        const {
            target: { value },
        } = event;
        setLevelType(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChangeCategory = (event) => {
        const {
            target: { value },
        } = event;
        setCategoryType(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChangeTimeStamp = (event) => {
        const {
            target: { value },
        } = event;
        setTimeStamp(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChangeFiles = (files) => {
        setFiles(files);
    }

    const [showPreview, setShowPreview] = React.useState(false);
    const [instructorInfo, setInstructorInfo] = React.useState(null);
    const [courseInstructorId, setCourseInstructorId] = React.useState(null);
    const [previewImageObjectUrl, setPreviewImageObjectUrl] = React.useState('');

    React.useEffect(() => {
        if (!files || files.length === 0) {
            setPreviewImageObjectUrl('');
            return;
        }
        const url = URL.createObjectURL(files[0]);
        setPreviewImageObjectUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [files]);

    React.useEffect(() => {
        if (!courseInstructorId) {
            setInstructorInfo(null);
            return;
        }
        let cancelled = false;
        fetch(`${globals.apiUrl}/auth/instructor/${courseInstructorId}`)
            .then((r) => r.ok ? r.json() : null)
            .then((data) => {
                if (!cancelled)
                    setInstructorInfo(data || null);
            })
            .catch(() => {
                if (!cancelled)
                    setInstructorInfo(null);
            });
        return () => {
            cancelled = true;
        };
    }, [courseInstructorId]);

    const buildPreviewCourse = () => {
        const instructorName = instructorInfo
            ? `${instructorInfo.first_name || ''} ${instructorInfo.last_name || ''}`.trim() || 'Учител'
            : (user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Учител' : 'Учител');
        return {
            id: courseId || 0,
            title: courseData.title || 'Без заглавие',
            description: courseData.description || '',
            price: Number(courseData.price) || 0,
            capacity: Number(numStudents) || 1,
            enrolled_students_count: students.length,
            student_requirements: toLinesArray(courseData.student_requirements || ''),
            example_topics: toLinesArray(courseData.example_topics || ''),
            included_materials: toLinesArray(courseData.included_materials || ''),
            good_for: Array.isArray(levelType) ? levelType : [],
            category: Array.isArray(categoryType) && categoryType.length > 0 ? categoryType : ['—'],
            image_url: previewImageObjectUrl || courseData.image_url || '/eacademiabg-logo.webp',
            duration: Number(timeStamp) || 60,
            instructor_id: courseInstructorId || (instructorInfo?.id ?? user?.id ?? 0),
            instructor_name: instructorName,
            instructor_image_url: instructorInfo?.image_url || user?.image_url || '/noone.webp',
            instructor_description: instructorInfo?.description || user?.description || '',
            showChat: false,
            saved: false,
        };
    };

    const handleOpenPreview = () => {
        setShowPreview(true);
    };

    const handleClosePreview = () => {
        setShowPreview(false);
    };

    const handleChangeStudent = (event) => {
        setNumStudents(event.target.value);
    };

    const toLinesArray = (text) => text
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

    const normalizeCoursePayload = (isPublishedValue) => {
        const normalizedData = {
            title: courseData.title,
            description: courseData.description,
            price: Number(courseData.price) || 0,
            good_for: levelType,
            category: categoryType,
            capacity: numStudents,
            duration: timeStamp,
            is_published: isPublishedValue,
        };

        if (courseData.student_requirements.length > 0)
            normalizedData.student_requirements = toLinesArray(courseData.student_requirements);
        if (courseData.example_topics.length > 0)
            normalizedData.example_topics = toLinesArray(courseData.example_topics);
        if (courseData.included_materials.length > 0)
            normalizedData.included_materials = toLinesArray(courseData.included_materials);

        return normalizedData;
    };

    const buildFormData = (payload) => {
        const formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        if (isEditMode) {
            if (files.length > 0)
                formData.append('file', files[0]);
        } else if (files.length > 0) {
            formData.append('file', files[0]);
        }

        return formData;
    };

    const handlePublishButton = (is_published) => async (e) => {
        e.preventDefault();
        if (loadingAction)
            return;

        setShowErrorMessage(false);
        setPublishButtonActive(false);
        setDraftPublishButtonActive(false);
        setLoadingAction(is_published ? 'publish' : 'draft');
        const requestPayload = normalizeCoursePayload(is_published);
        const formData = buildFormData(requestPayload);

        try {
            const response = await fetch(requestUrl, {
                method: requestType,
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    // 'Content-Type': 'multipart/form-data'
                },
            });

            const responseData = await response.json();
            if (!response.ok || responseData.detail) {
                setShowErrorMessage(true);
                return;
            }

            setCourseData((prevCourseData) => ({
                ...prevCourseData,
                title: responseData.title ?? prevCourseData.title,
                description: responseData.description ?? prevCourseData.description,
                student_requirements: Array.isArray(responseData.student_requirements)
                    ? responseData.student_requirements.join('\n')
                    : prevCourseData.student_requirements,
                example_topics: Array.isArray(responseData.example_topics)
                    ? responseData.example_topics.join('\n')
                    : prevCourseData.example_topics,
                included_materials: Array.isArray(responseData.included_materials)
                    ? responseData.included_materials.join('\n')
                    : prevCourseData.included_materials,
                is_published: responseData.is_published ?? prevCourseData.is_published,
                image_url: responseData.image_url ?? prevCourseData.image_url,
            }));

            if (Array.isArray(responseData.good_for))
                setLevelType(responseData.good_for);
            if (Array.isArray(responseData.category))
                setCategoryType(responseData.category);
            if (typeof responseData.capacity === "number")
                setNumStudents(responseData.capacity);
            if (typeof responseData.duration === "number")
                setTimeStamp(responseData.duration);

            if (is_published)
                setPublishButtonActive(true);
            else
                setDraftPublishButtonActive(true);
        } catch (error) {
            setShowErrorMessage(true);
            console.error('Error:', error);
        } finally {
            setLoadingAction(null);
        }
    }

    const handleChangeCourseData = (event) => {
        const { id, value } = event.target;
        setCourseData({
            ...courseData,
            [id]: value,
        });
    };

    const handleCheckCourseSlug = async () => {
        if (!isEditMode || !courseId || !token)
            return;
        setCourseSlugCheckLoading(true);
        setCourseSlugFeedback({ severity: 'info', text: '' });
        try {
            const q = new URLSearchParams({
                slug: courseUrlSlug.trim(),
                target_type: 'course',
                exclude_target_id: String(courseId),
            });
            const r = await fetch(`${globals.apiUrl}/admin/url-slugs/availability?${q}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                setCourseSlugFeedback({ severity: 'error', text: data.detail || 'Грешка при проверката' });
                return;
            }
            if (data.available)
                setCourseSlugFeedback({ severity: 'success', text: 'Този адрес е свободен.' });
            else
                setCourseSlugFeedback({ severity: 'warning', text: data.reason || 'Адресът не е свободен.' });
        } catch {
            setCourseSlugFeedback({ severity: 'error', text: 'Мрежова грешка при проверката.' });
        } finally {
            setCourseSlugCheckLoading(false);
        }
    };

    const handleSaveCourseSlug = async () => {
        if (!isEditMode || !courseId || !token)
            return;
        setCourseSlugSaveLoading(true);
        setCourseSlugFeedback({ severity: 'info', text: '' });
        try {
            const q = new URLSearchParams({
                slug: courseUrlSlug.trim(),
                target_type: 'course',
                exclude_target_id: String(courseId),
            });
            const check = await fetch(`${globals.apiUrl}/admin/url-slugs/availability?${q}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const checkData = await check.json().catch(() => ({}));
            if (!check.ok || !checkData.available) {
                setCourseSlugFeedback({
                    severity: 'error',
                    text: checkData.reason || checkData.detail || 'Адресът не е наличен за запис.',
                });
                setCourseSlugSaveLoading(false);
                return;
            }
            const cid = parseInt(courseId, 10);
            const r = await fetch(`${globals.apiUrl}/admin/url-slugs`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    slug: courseUrlSlug.trim(),
                    target_type: 'course',
                    target_id: cid,
                }),
            });
            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                setCourseSlugFeedback({ severity: 'error', text: data.detail || 'Неуспешен запис' });
                return;
            }
            if (data.slug)
                setCourseUrlSlug(data.slug);
            setCourseSlugFeedback({
                severity: 'success',
                text: 'Записано. Публичен път: /course/' + (data.slug || courseUrlSlug.trim()),
            });
        } catch {
            setCourseSlugFeedback({ severity: 'error', text: 'Мрежова грешка при записа.' });
        } finally {
            setCourseSlugSaveLoading(false);
        }
    };

    return (
        <Container>
            {isCourseLoading ?
                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 24, mt: 3 }}>
                    Зареждане на курса...
                </Typography> : null
            }
            {!isCourseLoading && courseLoadError ?
                <Typography sx={{ color: globals.colors.red, fontWeight: 'bold', fontSize: 18, mt: 3 }}>
                    {courseLoadError}
                </Typography> : null
            }
            {!isCourseLoading && !courseLoadError ?
            <>
            <Grid container direction={'column'}>
                <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 35, mb: 1 }}>Редактиране на курс "{courseData.title}"</Typography>

                {isEditMode ? (
                    <Grid container spacing={3} sx={{ mt: 2, mb: 3 }} alignItems="flex-start">
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Short url"
                                variant="filled"
                                value={courseUrlSlug}
                                onChange={(e) => setCourseUrlSlug(e.target.value)}
                                helperText="Само малки букви, цифри и тире. Публичен адрес: /course/…"
                                sx={{ minWidth: 260 }}
                            />
                        </Grid>
                        <Grid item>
                            <LoadingButton
                                loading={courseSlugCheckLoading}
                                variant='contained'
                                size={'small'}
                                onClick={handleCheckCourseSlug}
                                sx={{ backgroundColor: globals.colors.darkBlue, textTransform: 'none', mt: 2 }}
                            >
                                Провери
                            </LoadingButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton
                                loading={courseSlugSaveLoading}
                                variant='contained'
                                size={'small'}
                                onClick={handleSaveCourseSlug}
                                sx={{ backgroundColor: globals.colors.lightGreen, textTransform: 'none', mt: 2 }}
                            >
                                Запази
                            </LoadingButton>
                        </Grid>
                        {courseSlugFeedback.text ? (
                            <Grid item xs={12}>
                                <Alert severity={courseSlugFeedback.severity} sx={{ maxWidth: 720 }}>
                                    {courseSlugFeedback.text}
                                </Alert>
                            </Grid>
                        ) : null}
                    </Grid>
                ) : null}

                <Grid item sx={{ mt: 2 }}>
                    <TitleTypography value="Заглавие на курса" />
                    <EditCourseTF rowsMax={4} numRows={1} defaultValue={courseData.title} onChange={handleChangeCourseData} idName="title" />
                    <Paper elevation={4} sx={{ maxWidth: 300, mt: 3 }}>
                        <FileUpload
                            helpText={courseData.image_url ? 'Сменете изображението' : 'Добавете изображение'}
                            id={'multi-file-upload-1'}
                            onChange={handleChangeFiles}
                            uploadedFiles={courseData.image_url ? [courseData.image_url] : undefined}
                        />
                    </Paper>
                </Grid>
                <Typography sx={{ fontSize: 12, ml: 5, mt: 1 }}>Задължително поле</Typography>

                <Grid item sx={{ mt: 3 }}>
                    <Grid container sx={{ mb: 1 }}>
                        <TitleTypography value="Описание на курса" />
                        <Typography sx={{ mt: 0.5, ml: 2 }}>(каква е целта на курса, какво ще се учи, по какъв метод и т.н.)</Typography>
                    </Grid>
                    <RTE defaultValue={courseData.description} onChange={handleChangeCourseData} idName="description" />
                </Grid>
            </Grid>

            <Grid container sx={{ mt: 3 }} spacing={6}>
                <Grid item sx={12} sm={6}>
                    <TitleTypography value="Примерни теми по време на обучението" />
                    <Typography>(Избройте няколко теми, които може да обхваща курса. Всяка на нов ред.)</Typography>
                    <EditCourseTF multiple numRows={2} rowsMax={10} defaultValue={courseData.example_topics} onChange={handleChangeCourseData} idName="example_topics" />

                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mt: 5 }}>Включени материали
                        <Tooltip title="Материали, които учителят включва в курса. Например: учебници, сборници, онлайн материали за упражнение и други...">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <EditCourseTF multiple numRows={2} rowsMax={10} defaultValue={courseData.included_materials} onChange={handleChangeCourseData} idName="included_materials" />

                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mt: 5 }}>Изисквания
                        <Tooltip title="Изисквания към курса. Например: вече платен или изтеглен софтуер, специален учебник, добро настроение, желание за учене...">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <EditCourseTF multiple numRows={2} rowsMax={10} defaultValue={courseData.student_requirements} onChange={handleChangeCourseData} idName="student_requirements" />
                    {/* <Paper sx={{ backgroundColor: globals.colors.backgroundColor, mt: 2, }}>
                        <Grid justifyContent={'center'} alignContent={'center'} textAlign={'center'}>
                            <TextField id="title" label="Заглавие на Тема 1." variant="outlined" sx={{
                                backgroundColor: 'white',
                                borderRadius: 1,
                                color: globals.colors.textColor,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                    '&:hover fieldset': {
                                        borderColor: globals.colors.darkRed, // border color on hover
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: globals.colors.darkRed, // border color when focused
                                    },
                                }, width: '60vh', mt: 1, mb: 2,
                            }}
                                helperText="Задължително поле"
                            />
                            <FileUpload helpText={'Прикачи файл'} id={'multi-file-upload-2'} />
                        </Grid>
                        <Grid container justifyContent={'end'} alignItems={'end'} textAlign={'end'} sx={{ mr: 3 }}>
                            <CancelButton sx={{ mr: 2, textTransform: 'capitalize' }}>Отказ</CancelButton>
                            <OKButton sx={{ mr: 3 }}>OK</OKButton>
                        </Grid>
                    </Paper>
                    <AddTopicButton sx={{ mt: 2, textTransform: 'capitalize', fontWeight: 'bold', mb: 5 }}><AddIcon />Добавяне на тема</AddTopicButton> */}

                    <Grid container sx={{ mt: 3 }}>
                        <Grid item sm={12}>
                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                                Активни ученици {!isStudentsLoading && !studentsLoadError ? `(${students.length})` : null}
                            </Typography>
                        </Grid>

                        {isStudentsLoading ?
                            <Grid item sm={12} sx={{ mt: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <CircularProgress size={20} />
                                <Typography sx={{ color: globals.colors.gray }}>Зареждане на учениците...</Typography>
                            </Grid> : null
                        }

                        {!isStudentsLoading && studentsLoadError ?
                            <Grid item sm={12} sx={{ mt: 3 }}>
                                <Typography sx={{ color: globals.colors.darkRed }}>{studentsLoadError}</Typography>
                            </Grid> : null
                        }

                        {!isStudentsLoading && !studentsLoadError && students.length === 0 ?
                            <Grid item sm={12} sx={{ mt: 3 }}>
                                <Typography sx={{ color: globals.colors.gray }}>Все още няма записани ученици.</Typography>
                            </Grid> : null
                        }

                        {!isStudentsLoading && students.map(student => (
                            <Grid key={student.student_id} item sm={12} sx={{ mt: 3 }}>
                                <Paper sx={{ p: 3 }}>
                                    <Grid container justifyContent={'space-between'} alignItems={'center'}>
                                        <Grid item sm={9}>
                                            <Grid container alignItems={'center'} spacing={2}>
                                                <Grid item>
                                                    <Avatar src={student.student_image_url || undefined} alt={student.student_name}>
                                                        {!student.student_image_url && student.student_name ? student.student_name.charAt(0) : null}
                                                    </Avatar>
                                                </Grid>
                                                <Grid item sx={{ textAlign: 'left' }}>
                                                    <Typography sx={{ fontWeight: 'bold' }}>{student.student_name}</Typography>
                                                    <Typography sx={{ color: globals.colors.gray, fontSize: 14 }}>@{student.student_username}</Typography>
                                                    <Typography sx={{ fontSize: 14 }}>{student.student_email}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <IconButton
                                                disabled={removingStudentId != null}
                                                onClick={() => handleRemoveUser(student.student_id)}
                                                aria-label="Премахни ученик"
                                            >
                                                {removingStudentId === student.student_id
                                                    ? <CircularProgress size={22} />
                                                    : <DeleteIcon />}
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        ))}

                        <Grid item sx={{ mt: 3 }}>
                            <Button variant="contained" startIcon={<AddIcon />} onClick={handleClickOpen}>
                                Добави
                            </Button>
                            {studentsActionError ?
                                <Typography sx={{ mt: 2, color: globals.colors.darkRed }}>{studentsActionError}</Typography> : null}
                            <Dialog open={openDialog} onClose={() => { if (!enrollSubmitting) handleClose(); }} fullWidth>
                                <DialogTitle>Добави ученик</DialogTitle>
                                <DialogContent>
                                    <form onSubmit={handleAddStudent} id="subscription-form">
                                        <TextField
                                            autoFocus
                                            required
                                            margin="dense"
                                            id="student-email-or-id"
                                            name="student_email_or_id"
                                            label="Имейл или ID на ученик"
                                            type="text"
                                            fullWidth
                                            variant="standard"
                                            value={studentToAdd}
                                            helperText="Числовият ID се вижда в администраторския списък с потребители."
                                            onChange={(event) => setStudentToAdd(event.target.value)}
                                        />
                                        {enrollDialogError ?
                                            <Typography sx={{ mt: 2, color: globals.colors.darkRed }}>{enrollDialogError}</Typography> : null}
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose} disabled={enrollSubmitting}>Откажи</Button>
                                    <LoadingButton
                                        type="submit"
                                        form="subscription-form"
                                        loading={enrollSubmitting}
                                        variant="contained"
                                    >
                                        Добави
                                    </LoadingButton>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                    </Grid>

                </Grid>

                <Grid item sx={12} sm={6}>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                        Kатегория
                        <Tooltip title="Може курсът да попада в повече от една категория, затова може да изберете повече от една. Ако няма категорията, която търсите се свържете с eAcademiaBg.">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <Grid container sx={{ mt: 1, mb: 5 }}>
                        <FormControl sx={{ width: 400 }}>
                            <Select
                                labelId="demo-multiple-chip-label"
                                id="demo-multiple-chip"
                                multiple
                                value={categoryType}
                                onChange={handleChangeCategory}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Box>
                                )}
                                MenuProps={MenuProps}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                {
                                    categories.map((category) => (
                                        <MenuItem
                                            key={category}
                                            value={category}
                                            style={getStyles(category, categoryType, theme)}
                                        >
                                            {category}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                    </Grid>

                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                        Подходящ за
                        <Tooltip title="Може курсът да е подходящ за повече от едно ниво. Моля, изберете всички нива, които са подходящи.">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <Grid container sx={{ mt: 1 }}>
                        <FormControl sx={{ width: 400 }}>
                            {/* <InputLabel id="demo-multiple-chip-label">Chip</InputLabel> */}
                            <Select
                                labelId="demo-multiple-chip-label"
                                id="demo-multiple-chip"
                                multiple
                                value={levelType}
                                onChange={handleChangeLevel}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Box>
                                )}
                                MenuProps={MenuProps}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                {
                                    levels.map((level) => (
                                        <MenuItem
                                            key={level}
                                            value={level}
                                            style={getStyles(level, levelType, theme)}
                                        >
                                            {level}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid sx={{ mt: 5 }}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                            Максимален брой ученици,
                            на които можете да преподавате
                            <Tooltip title="Уроците са индивидуални, а не групови. Моля, отбележете на колко ученика на седмица можете да направите индивидуален урок.">
                                <InfoIcon fontSize="small" />

                            </Tooltip>
                        </Typography>

                        <FormControl required sx={{ minWidth: 120, mt: 1 }}>
                            {/* <InputLabel id="demo-simple-select-required-label">Age</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-required-label"
                                id="demo-simple-select-required"
                                value={numStudents}
                                // label="Age *"
                                onChange={handleChangeStudent}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={6}>6</MenuItem>
                                <MenuItem value={7}>7</MenuItem>
                                <MenuItem value={8}>8</MenuItem>
                                <MenuItem value={9}>9</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid container sx={{ mt: 3 }} sm={8}>
                        <TitleTypography value="Продължителност на един урок" />
                        {/* 45, 60, 90, 120 */}
                        <FormControl required sx={{ minWidth: 120, mt: 1 }}>
                            {/* <InputLabel id="demo-simple-select-required-label">Age</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-required-label"
                                id="demo-simple-select-required"
                                value={timeStamp}
                                // label="Age *"
                                onChange={handleChangeTimeStamp}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                <MenuItem value={45}>45 мин</MenuItem>
                                <MenuItem value={60}>1 час</MenuItem>
                                <MenuItem value={90}>1 час 30 мин</MenuItem>
                                <MenuItem value={120}>2 часа</MenuItem>
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                        {/* <EditCourseTF /> */}
                    </Grid>
                    <Grid container sx={{ mt: 3 }} >
                        <Grid item sm={12}>
                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                                Цена
                                <Tooltip title="Цената включва 20% комисионна и сумата, която отива при учителя.">
                                    <InfoIcon fontSize="small" />
                                </Tooltip>
                            </Typography>
                        </Grid>
                        <Grid item >
                            <FormControl sx={{ m: 1 }} variant="standard">
                                <Input
                                    id='price'
                                    type="number"
                                    inputProps={{ min: 0, step: 0.01 }}
                                    onChange={handleChangeCourseData}
                                    value={courseData.price}
                                    startAdornment={<InputAdornment position="start">€</InputAdornment>}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <Tooltip title={formatLevaTooltip(Number(courseData.price) || 0)}>
                                                <InfoIcon fontSize="small" sx={{ color: globals.colors.darkBlue }} />
                                            </Tooltip>
                                        </InputAdornment>
                                    }
                                />
                                <FormHelperText>Цената се въвежда само в евро. Левовата стойност се изчислява автоматично.</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid container spacing={2} justifyContent={'center'} sx={{ mt: 2 }}>
                    <Grid item>
                        <Button
                            variant='contained'
                            type='submit'
                            size='large'
                            disabled={loadingAction !== null}
                            startIcon={loadingAction === 'publish' ? <CircularProgress size={18} sx={{ color: globals.colors.backgroundColor }} /> : null}
                            sx={{
                                mt: 3, px: 7, backgroundColor: globals.colors.lightRed, '&:hover': {
                                    backgroundColor: globals.colors.darkRed,
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: globals.colors.lightRed,
                                    color: globals.colors.backgroundColor,
                                    opacity: 0.7,
                                },
                                mb: 5,
                            }}
                            onClick={handlePublishButton(true)}
                        >
                            {loadingAction === 'publish' ? 'Публикуване...' : 'Публикувай'}
                        </Button>
                        {(publishButtonActive) ?
                            <Typography sx={{ mt: 1, color: globals.colors.gray }}>{user.admin == 'admin' ? "Успешно публикувахте курса!" : (courseData.is_approved ? "Успешно публикувахте курса!" : "Успешно изпратена заявка за \n публикуване на курса!")}</Typography> : null
                        }
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            type='submit'
                            size='large'
                            disabled={loadingAction !== null}
                            startIcon={loadingAction === 'draft' ? <CircularProgress size={18} sx={{ color: globals.colors.backgroundColor }} /> : null}
                            sx={{
                                mt: 3, px: 7, backgroundColor: globals.colors.darkBlue, '&:hover': {
                                    backgroundColor: globals.colors.lightBlue,
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: globals.colors.darkBlue,
                                    color: globals.colors.backgroundColor,
                                    opacity: 0.7,
                                },
                            }}
                            onClick={handlePublishButton(false)}
                        >
                            {loadingAction === 'draft' ? 'Запазване...' : 'Чернова'}
                        </Button>
                        {(draftPublishButtonActive) ?
                            <Typography sx={{ mt: 1, color: globals.colors.gray }}>Успешно запазихте черновата!</Typography> : null
                        }
                    </Grid>
                    <Grid item>
                        <Button
                            variant='outlined'
                            size='large'
                            disabled={loadingAction !== null}
                            startIcon={<VisibilityIcon />}
                            onClick={handleOpenPreview}
                            sx={{
                                mt: 3, px: 7,
                                color: globals.colors.lightGreen,
                                borderColor: globals.colors.lightGreen,
                                '&:hover': {
                                    color: globals.colors.darkGreen,
                                    borderColor: globals.colors.darkGreen,
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            Преглед
                        </Button>
                    </Grid>
                    {showErrorMessage ? <Typography sx={{ mt: 1, color: globals.colors.red }}>Възникна грешка при публикуването на курса. Моля, проверете дали сте запълнили всички полета правилно.</Typography> : null}
                </Grid>
            </Grid>
            </>
            : null}

            <Dialog
                fullScreen
                open={showPreview}
                onClose={handleClosePreview}
                TransitionComponent={PreviewTransition}
            >
                <AppBar sx={{ position: 'sticky', backgroundColor: globals.colors.darkBlue }}>
                    <Toolbar>
                        <Typography sx={{ flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
                            Преглед на курса (текущи промени, без запис)
                        </Typography>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={handleClosePreview}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Box sx={{ py: 3, backgroundColor: globals.colors.backgroundColor, minHeight: '100%' }}>
                    {showPreview ? <CoursePage course={buildPreviewCourse()} showPublish={false} /> : null}
                </Box>
            </Dialog>
        </Container >
    );
}

export default EditCourseAdmin;